import React from 'react';
import staffPicksImage from './staff-picks.png';

const StaffPicks = ({ project, ...rest }) => {
  return project.recommended_at !== '' ? (
    <img src={staffPicksImage} title="Staff Pick" {...rest} alt="Twine" />
  ) : (
    <noscript />
  );
};

export default StaffPicks;
